// components/common/Skeleton.tsx
import React from "react";

export default function Skeleton({ height }) {
    return (
        <div
            style={{
                height,
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                margin: "16px 0",
                animation: "pulse 1.5s infinite ease-in-out",
            }}
        />
    );
}
